import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/currency-converter-calculator',
  component: () => import('../../routes/CurrencyConverterCalculator.svelte'),
  card: {
    id: 'currency-converter',
    title: 'Currency Converter',
    description: 'Convert between major world currencies with live exchange rates.',
    icon: 'currency_exchange',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/currency-converter-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Currency Converter Calculator – Live Exchange Rates',
    description: 'Free currency converter calculator. Convert between USD, EUR, GBP, JPY, CAD, AUD, CHF and more major world currencies with accurate exchange rates.',
  },
};

export default meta;